import React from 'react';
import { CalendarIcon } from 'lucide-react';
export const Hero = () => {
  return <div className="relative min-h-screen overflow-hidden" data-id="element-157">
      {/* Background with overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black/70 opacity-90 z-10" data-id="element-158"></div>
      <div className="absolute inset-0 bg-black" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/jUfc9uPw46KpugPKDJAQkR/chrome_89DLcjH9TT.jpg')",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.6
    }} data-id="element-159"></div>
      {/* Hero Content */}
      <div className="relative z-20 flex flex-col items-center justify-center min-h-screen px-4 py-16 text-center text-white" data-id="element-160">
        <div className="max-w-3xl mx-auto" data-id="element-161">
          <h1 className="text-4xl md:text-6xl font-black leading-tight mb-8 text-shadow-lg" data-id="element-162">
            WORDS THAT CONVERT
            <br data-id="element-163" />
            <span className="bg-gradient-to-r from-green-500 to-green-600 text-transparent bg-clip-text block" data-id="element-164">
              BROWSERS INTO BUYERS
            </span>
          </h1>
          <p className="text-lg md:text-xl opacity-95 font-medium leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-165">
            Struggling to convert visitors?
            <br data-id="element-166" />
            We write copy that turns your traffic into paying customers for
            businesses, brands, and creators.
          </p>
          {/* Video Section */}
          {/* CTA Button */}
          <a href="https://calendly.com/mayhave/30min" className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold text-lg uppercase tracking-wide py-5 px-14 rounded-full shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl mb-4 mt-8" data-id="element-167">
            BOOK YOUR STRATEGY CALL! 📞
          </a>
          <p className="text-base opacity-80 mb-10" data-id="element-168">
            Book a strategy call to learn how we can turn your copy into
            customers.
          </p>
          {/* Social Proof */}
          <div className="flex flex-col items-center" data-id="element-169">
            <div className="flex justify-center mb-4" data-id="element-170">
              {['CG', 'DW', 'JP', '+'].map((initials, index) => <div key={index} className="w-11 h-11 rounded-full bg-gradient-to-r from-green-600 to-green-700 border-2 border-white flex items-center justify-center text-white font-semibold text-sm -ml-2 first:ml-0" data-id="element-171">
                  {initials}
                </div>)}
            </div>
            <div className="text-green-500 text-2xl mb-2" data-id="element-172">★★★★★</div>
            <p className="text-base font-semibold" data-id="element-173">Delivering results customers trust.</p>
          </div>
        </div>
      </div>
    </div>;
};